import { Grid, styled, Theme } from '@mui/material';
import { WsColors } from 'wisestep-base';

interface IEmailFooterProps {
  theme: Theme;
  size?: string;
}

const EmailFooter = styled(Grid)(({ theme }: IEmailFooterProps) => ({
  position: 'fixed',
  columnGap: theme.spacing(1),
  bottom: 1,
  width: '52vw',
  overflowX: 'scroll',
  display: 'flex',
  right: 0,
  background: WsColors.White,
}));

export default EmailFooter;
